execv2.messages.objects = {

    container: document.getElementById("containerMessages"),
    containerRender: document.getElementById("tblMessageBody"),
    spinner: document.getElementById("spinnerMessages"),
    inpDsMessage: document.getElementById("inpDsMessage"),
    chkRequesterMessage: document.getElementById("inpChkStRequesterMessage"),
    counter: document.querySelector(".count-messages"),
    btnAddMessage: document.getElementById("btnAddMessage"),
    template: '<tr class="p-2 m-2" data-id="{CodMessage}" id="message-{CodMessage}">\
                    <td class="avatar">{Avatar}\
                        <input type="hidden" name="inpDsMessageBody" id="inpDsMessageBody" value=\'{Message}\'/>\
                        <input type="hidden" name="inpStRequesterMessage" id="inpStRequesterMessage" value="{RequesterCanSee}"/>\
                    </td>\
                    <td class="message ">\
                        <div><h5 class="d-inline bold">{User}</h5> <span class="small text-lowercase {ShowUserOriginal}">({UserOriginalLabel} {UserOriginal})</span></div>\
                        <div class="message-box no-horizontal-scroll bg-{MessageColor}" style="word-break: break-word">{Message}</div>\
                        <div class="text-right pt-1"><span class="small">{Date}, {Hour} {TaskTitle}</span> <span class="badge badge-light">#{CodFlowExecute}</span></div>\
                    </td>\
                    <td class="lock d-none d-lg-table-cell"><i class="ico-lock ico-sm text-dark {IsLocked}"></i></td>\
                    <td class="del d-none d-lg-table-cell"><a href="javascript:void(0)" class="{ShowDelete}" onclick="execv2.messages.delete(this)" ><i class=\"ico-delete ico-sm text-danger\"></i></a></td>\
                </tr>'
}

execv2.messages.setup = function () {



    h.addEventListener(execv2.messages.objects.inpDsMessage, "keyup", execv2.messages.type);
    h.addEventListener(execv2.messages.objects.btnAddMessage, "click", execv2.messages.add);

}

execv2.messages.type = function() {

    if (execv2.messages.objects.inpDsMessage.value.length > 0)
        execv2.messages.enabled();
    else
        execv2.messages.disabled();

}

execv2.messages.disabled = function () {

    execv2.messages.objects.btnAddMessage.setAttribute("disabled", "disabled");
    h.addClass(execv2.messages.objects.btnAddMessage, "disabled");
}

execv2.messages.enabled = function () {

    execv2.messages.objects.btnAddMessage.removeAttribute("disabled");
    h.removeClass(execv2.messages.objects.btnAddMessage, "disabled");
}


execv2.messages.add = function () {

    let dsMessageEncoded = execv2.util.htmlEncode(execv2.messages.objects.inpDsMessage?.value);
    dsMessageEncoded = dsMessageEncoded.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
    dsMessageEncoded = execv2.util.identifyMention(execv2.util.breaklineWithBr(dsMessageEncoded));
    let hiddenMessageEncoded = execv2.util.htmlEncode(execv2.messages.objects.inpDsMessage?.value).replace(/'/g, "\\'").replace(/\$/g, "$$$$");

    let html = execv2.messages.objects.template;
    html = html.replace(/{CodMessage}/gi, "");
    html = html.replace(/{Avatar}/gi, execv2.objects.containerActorAvatar);
    html = html.replace(/{MessageColor}/gi, execv2.messages.objects.chkRequesterMessage.checked ? "light-success" : "light");
    html = html.replace(/{IsLocked}/gi, execv2.messages.objects.chkRequesterMessage.checked ? "d-none" : "");
    html = html.replace(/{RequesterCanSee}/gi, execv2.messages.objects.chkRequesterMessage.checked ? "S" : "N");
    html = html.replace(/{Date}/gi, new Date().toLocaleDateString());
    html = html.replace(/{Hour}/gi, new Date().toLocaleTimeString());
    html = html.replace(/{User}/gi, execv2.objects.hidDsActorName.value);
    html = html.replace(/{UserOriginal}/gi, "");
    html = html.replace(/{ShowUserOriginal}/gi, "d-none");
    html = html.replace(/value='([^']*)'/i, "value='" + hiddenMessageEncoded + "'");
    html = html.replace(/{Message}/gi, dsMessageEncoded);
    html = html.replace(/{TaskTitle}/gi, "");
    html = html.replace(/{ShowDelete}/gi, "");
    html = html.replace(/{CodFlowExecute}/gi, execv2.objects.codFlowExecute != "" ? execv2.objects.codFlowExecute : "");

    execv2.messages.objects.containerRender.insertAdjacentHTML('beforeend', html);

    execv2.ui.increaseCounter(execv2.messages.objects.counter);

    var el = execv2.messages.objects.containerRender.lastChild;

    bsml.convertIcons(execv2.messages.objects.containerMessages);
    
    if (execv2.objects.isTask) {

        execv2.messages.spinner.show();

        var postdata = {
            "m": "add",
            "cfe": execv2.objects.codFlowExecute,
            "cfeu": execv2.objects.codFlowExecuteUID,
            "cfet": execv2.objects.codFlowExecuteTask,
            "me": execv2.messages.objects.inpDsMessage.value,
            "rcs": execv2.messages.objects.chkRequesterMessage.checked ? "S" : "N",
            "inpCodUsersPending": ""
        };

        h.postJSON(
            execv2.services.urlMessages + "?" + (new URLSearchParams(postdata).toString()),
            function (data) {

                if (data != null && data.success != null) {

                    el.closest("tr").setAttribute("data-id", data.success);

                }

                execv2.messages.objects.inpDsMessage.value = "";
                execv2.messages.disabled();
                execv2.messages.spinner.hide();
            }
        );
    } else {

        execv2.messages.objects.inpDsMessage.value = "";


    }
}


execv2.messages.delete = function (el) {

    var tr = el.closest("tr");
    var id = tr.getAttribute("data-id");

    if (execv2.objects.isTask) {

        if (id && id != "" && id != 0) {

            bsml.confirm(null, function () { 

                execv2.messages.spinner.show();

                var postdata = {
                    "m": "del",
                    "cm": id,
                    "cfet": execv2.objects.codFlowExecuteTask
                };

                h.postJSON(
                    execv2.services.urlMessages + "?" + (new URLSearchParams(postdata).toString()),
                    function (data) {

                        if (data != null && data.success != null) {

                            execv2.messages.objects.containerRender.removeChild(tr);
                        }
                        execv2.messages.spinner.hide();
                    }
                );
            });

        }
    } else {

        execv2.messages.objects.containerRender.removeChild(tr);

    }
}

execv2.messages.list = function () {

    if (!execv2.objects.isTask)
        return;

    if (execv2.messages.objects.containerRender === null)
        return;


    execv2.messages.spinner.show();

    var postdata = {
        "cfe": execv2.objects.codFlowExecute,
        "cfet": execv2.objects.codFlowExecuteTask
    }

    h.postJSON(
        execv2.services.urlMessages + "?" + (new URLSearchParams(postdata).toString()),
        function (data) {

            if (data != null && data.success != null) {

                h.forEach(data.success, function (i, item) {

                    var html = execv2.messages.objects.template;
                    html = html.replace(/{Avatar}/gi, item.av);
                    html = html.replace(/{CodMessage}/gi, item.cmenc);
                    html = html.replace(/{CodFlowExecute}/gi, item.cfe);
                    html = html.replace(/{IsLocked}/gi, item.req ? "d-none" : "");
                    html = html.replace(/{Date}/gi, item.dt);
                    html = html.replace(/{Hour}/gi, item.hr);
                    html = html.replace(/{Message}/gi, execv2.util.identifyMention(item.bd));
                    html = html.replace(/{MessageColor}/gi, item.req ? "light-success" : "light");
                    html = html.replace(/{ShowDelete}/gi, item.del ? "" : "d-none");
                    html = html.replace(/{ShowUserOriginal}/gi, item.uon != "" ? "" : "d-none");
                    html = html.replace(/{TaskTitle}/gi, item.dtt);
                    html = html.replace(/{User}/gi, item.dn);
                    html = html.replace(/{UserOriginal}/gi, item.uon);
                    html = html.replace(/{UserOriginalLabel}/gi, item.uont);

                    execv2.messages.objects.containerRender.insertAdjacentHTML('beforeend', html);
                    execv2.ui.increaseCounter(execv2.messages.objects.counter);
                    var el = execv2.messages.objects.containerRender.lastChild;
                    bsml.convertIcons(execv2.messages.objects.containerMessages);

                });
            }

            execv2.messages.spinner.hide();

        }
    );
}

execv2.messages.spinner = {

    show: function () {
        h.removeClass(execv2.messages.objects.spinner, "d-none");
    },
    hide: function () {
        h.addClass(execv2.messages.objects.spinner, "d-none");
    }
}


execv2.messages.setup();
execv2.messages.list();



